import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import { CommonModule } from "@angular/common";
import { PowertrainModalComponent } from "../powertrain-modal/powertrain-modal.component";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { NgbPopover, NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-powertrain-ytd-savings",
  templateUrl: "./powertrain-ytd-savings.component.html",
  styleUrls: ["./powertrain-ytd-savings.component.scss"],
  standalone: true,
  imports: [CommonModule, PowertrainModalComponent, MatButtonModule,MatTooltip,MatTooltipModule,NgbPopover,NgbPopoverModule],
  encapsulation: ViewEncapsulation.None
})
export class PowertrainYtdSavingsComponent implements OnInit {
  powertrainYTDUrl = BaseUrlConstantsService.POWERTRAIN_YTD_METRICS_API; // /powertrain/ytdcost/:subsystemId

  @Input("subsystem_id") subsystemId!: string | number;
  @Input("client_id") client_id!: string | number;

  ytdMetrics: any = {};
  ytdMetricsLoader: boolean = false;
  showModal: boolean = false;

  ytdMetricsV2: any = {};
  showYTDModal: boolean = false;
  constructor(private service: PowerTrainService) {}

  ngOnInit() {
    // this.fetchYTDMetrics();
    this.fetchYTDMetricsV2();
  }

  fetchYTDMetrics() {
    this.ytdMetricsLoader = true;
    this.service
      .fetchYTDMetricsData(this.powertrainYTDUrl + this.subsystemId)
      .then((ytdRes: any) => {
        this.ytdMetrics = {
          ...ytdRes.data,
          unexpected_failures: "₹" + ytdRes.data.unexpected_failures,
          failures_cost: "₹" + ytdRes.data.failures_cost,
          net_failures_cost: "₹" + ytdRes.data.net_failures_cost,
        };
      })
      .catch((err) => {
        console.log(err);
        this.ytdMetrics = {
          unexpected_failures: "N/A",
          failures_cost: "N/A",
          net_failures_cost: "N/A",
          client_id: this.client_id,
          subsystem_id: this.subsystemId,
        };
      })
      .finally(() => {
        this.ytdMetricsLoader = false;
      });
  }

  updateYTDMetrics() {
    this.showModal = true;
  }

  closeBox(data: any) {
    console.log("Received data:", data); // This will now correctly log the emitted data.
    this.showModal = false;

    if (data?.updatedData) {
      const { unexpected_failures, failures_cost, net_failures_cost } =
        data.updatedData;
      this.ytdMetrics.unexpected_failures = "₹" + unexpected_failures;
      this.ytdMetrics.failures_cost = "₹" + failures_cost;
      this.ytdMetrics.net_failures_cost = "₹" + Math.floor(net_failures_cost);
    }
  }

  fetchYTDMetricsV2() {
    this.ytdMetricsLoader = true;
    this.service
      .fetchYTDMetricsDataV2(this.powertrainYTDUrl + this.subsystemId)
      // .fetchYTDMetricsDataV2(
      //   `http://localhost:7777/powertrain/ytd-failures/` + this.subsystemId
      // )
      .then((ytdRes: any) => {
        if (ytdRes.error == false) {
          const { failures_count, total_cost, total_savings } = ytdRes.data;
          this.ytdMetricsV2 = {
            failures_count,
            total_cost:`₹${total_cost}`,
            total_savings: total_savings=='not enough Data'?'Not Enough Data':`₹${total_savings}`,
          };
        }
      })
      .catch((err) => {
        this.ytdMetricsV2 = {
          failures_count:'N/A',
            total_cost:'N/A',
            total_savings:'N/A'
        };
      })
      .finally(() => {
        this.ytdMetricsLoader = false;
      });
  }

  openYTDBox() {
    this.showYTDModal = true;
  }
  closeYTDBox(data: any) {
    this.showYTDModal = false;
    if (data.reload) {
      this.fetchYTDMetricsV2();
    }
  }
}
